import { useState } from 'react'

import { useBackButton } from '../../hooks/useBackButton'
import { ForgotPasswordScreen } from './ForgotPasswordScreen'
import { LoginScreen } from './LoginScreen'
import { RegisterScreen } from './RegisterScreen'
import { ResetPasswordScreen } from './ResetPasswordScreen'

type AuthView = 'login' | 'register' | 'forgot' | 'reset'

// Ссылка из письма сброса: /reset-password?token=… (SW отдаёт index.html).
const readResetToken = (): string | null => {
  if (typeof window === 'undefined') return null
  if (!window.location.pathname.includes('reset-password')) return null
  const token = new URLSearchParams(window.location.search).get('token')?.trim()
  return token ? token : null
}

/**
 * Экраны для неавторизованного пользователя. Свой роутинг локальным состоянием
 * (в PWA нет react-router); системная кнопка «Назад» возвращает на вход.
 */
export const AuthFlow = () => {
  const [resetToken] = useState(readResetToken)
  const [view, setView] = useState<AuthView>(() => (readResetToken() ? 'reset' : 'login'))

  const toLogin = () => {
    // Чистим reset-URL, чтобы перезагрузка не возвращала на экран сброса.
    if (window.location.pathname !== '/') {
      window.history.replaceState(null, '', '/')
    }
    setView('login')
  }

  // Android/браузер back с под-экранов → назад ко входу.
  useBackButton(view !== 'login', toLogin)

  switch (view) {
    case 'register':
      return <RegisterScreen onBack={toLogin} />
    case 'forgot':
      return <ForgotPasswordScreen onBack={toLogin} />
    case 'reset':
      return <ResetPasswordScreen token={resetToken ?? ''} onBack={toLogin} onDone={toLogin} />
    case 'login':
    default:
      return (
        <LoginScreen onRegister={() => setView('register')} onForgot={() => setView('forgot')} />
      )
  }
}
